import { Dialog, DialogActions, DialogContent } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';

import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Icon from '@mui/material/Icon';
import ChatBox from 'pages/chatbox';
import MDButton from 'components/MDButton';
import { useGetChatAssistantQuery } from 'services/assistantApi';

function AssistantPlayDialog({ assistantCode, dialogOpen, setDialogOpen }) {
  const { formatMessage: msg } = useIntl();

  const { data: assistant } = useGetChatAssistantQuery({ assistantCode });

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  return (
    <Dialog
      open={dialogOpen}
      onClose={handleCloseDialog}
      fullWidth
      maxWidth="lg"
      PaperProps={{
        sx: {
          height: '90vh',
          maxHeight: '90vh'
        }
      }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
        <Icon
          fontSize="large"
          sx={{
            color: (theme) => theme.palette.primary.main,
            mr: 1
          }}
        >
          {assistant?.icon ?? 'assistant_rounded'}
        </Icon>
        {assistant?.label}
      </DialogTitle>
      <DialogContent sx={{ padding: 0, margin: 0, height: '100%', display: 'flex' }} dividers>
        <ChatBox assistant={assistant} />
      </DialogContent>
      <DialogActions>
        <MDButton onClick={handleCloseDialog} color="secondary">
          {msg({ id: 'button.close' })}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}

AssistantPlayDialog.propTypes = {
  assistantCode: PropTypes.string,
  dialogOpen: PropTypes.bool.isRequired,
  setDialogOpen: PropTypes.func.isRequired
};

export default AssistantPlayDialog;
